export default "__VITE_PUBLIC_ASSET__a85e38bd__"